import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { utils } from '~/utils';
import BottomArea from './BottomArea';
import { makeSectionsFromServices } from './makeSectionsFromServices';
import PackageCard from './PackageCard';
import styles from './PackageSelector.module.scss';
import ServiceItem from './ServiceItem';
import ServicesSection from './ServicesSection';
const sectionTitle = (id, sum)=>{
    if (id === 'optional') {
        return 'Optional services';
    } else if (id === 'variable') {
        return 'Variable';
    } else if (sum != null) {
        return utils.formatDollarAmount(sum);
    }
};
export default function PackageSelector(param) {
    let { packages, isEffectiveDateInFuture, selectedBundleID, isMobile = false, onSelect } = param;
    return /*#__PURE__*/ _jsx("ul", {
        className: classNames(styles.packagesList, {
            [styles.mobile]: isMobile
        }),
        children: packages.map((param, idx)=>{
            let { id, name, services } = param;
            const bundleTestPrefix = "package-".concat(id);
            return /*#__PURE__*/ _jsx(PackageCard, {
                id: id,
                name: name,
                testId: "package-card-".concat(idx),
                bottomArea: /*#__PURE__*/ _jsx(BottomArea, {
                    selected: id === selectedBundleID,
                    testId: bundleTestPrefix,
                    onClick: ()=>onSelect(id)
                }),
                children: makeSectionsFromServices(services, {
                    isEffectiveDateInFuture
                }).map((param)=>{
                    let { id, services, category, subtitle, sum, hasOptionalServices, id: sectionID } = param;
                    return /*#__PURE__*/ _jsx(ServicesSection, {
                        hasOptionalServices: hasOptionalServices,
                        title: sectionTitle(id, sum),
                        subtitle: subtitle,
                        category: category,
                        testId: "".concat(bundleTestPrefix, "-section-").concat(sectionID),
                        children: services.map((param)=>{
                            let { id: serviceID, name, description, variablePriceText, includedServices } = param;
                            return /*#__PURE__*/ _jsx(ServiceItem, {
                                name: name,
                                description: description,
                                includedServices: includedServices,
                                variablePriceText: variablePriceText,
                                testId: "".concat(bundleTestPrefix, "-service-").concat(serviceID)
                            }, serviceID);
                        })
                    }, sectionID);
                })
            }, id);
        })
    });
}
